import { render, staticRenderFns } from "./NotAllowedIcon.vue?vue&type=template&id=055ba194&"
import script from "./NotAllowedIcon.vue?vue&type=script&lang=js&"
export * from "./NotAllowedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports